import React from 'react';

const Loader = ({ 
  size = 'medium', 
  variant = 'spinner', 
  color = 'primary',
  text = 'Carregando...',
  fullScreen = false,
  overlay = false,
  className = ''
}) => {
  const getSizeClasses = () => {
    switch(size) {
      case 'small': return 'w-6 h-6';
      case 'large': return 'w-16 h-16';
      default: return 'w-10 h-10';
    }
  };

  const getColorClasses = () => {
    switch(color) {
      case 'primary': return 'text-primary-600';
      case 'accent': return 'text-accent-600';
      case 'success': return 'text-green-600';
      case 'warning': return 'text-yellow-600';
      case 'error': return 'text-red-600';
      case 'white': return 'text-white';
      default: return 'text-primary-600';
    }
  };

  const getBorderColorClasses = () => {
    switch(color) {
      case 'primary': return 'border-primary-600';
      case 'accent': return 'border-accent-600';
      case 'success': return 'border-green-600';
      case 'warning': return 'border-yellow-600';
      case 'error': return 'border-red-600';
      case 'white': return 'border-white';
      default: return 'border-primary-600';
    }
  };

  const renderVariant = () => {
    const sizeClass = getSizeClasses();
    const colorClass = getColorClasses();
    const borderColorClass = getBorderColorClasses();

    switch(variant) {
      case 'spinner':
        return (
          <div className={`${sizeClass} animate-spin rounded-full border-4 border-gray-200 ${borderColorClass} border-t-transparent`} />
        );
      
      case 'dots':
        return (
          <div className="flex space-x-1">
            <div className={`w-2 h-2 ${colorClass.replace('text-', 'bg-')} rounded-full animate-bounce`} style={{animationDelay: '0ms'}} />
            <div className={`w-2 h-2 ${colorClass.replace('text-', 'bg-')} rounded-full animate-bounce`} style={{animationDelay: '150ms'}} />
            <div className={`w-2 h-2 ${colorClass.replace('text-', 'bg-')} rounded-full animate-bounce`} style={{animationDelay: '300ms'}} />
          </div>
        );
      
      case 'pulse':
        return (
          <div className={`${sizeClass} ${colorClass.replace('text-', 'bg-')} rounded-full animate-pulse`} />
        );
      
      case 'bars':
        return (
          <div className="flex space-x-1 items-end">
            {[...Array(5)].map((_, i) => (
              <div
                key={i}
                className={`w-1 ${colorClass.replace('text-', 'bg-')} animate-pulse`}
                style={{
                  height: `${12 + i * 4}px`,
                  animationDelay: `${i * 100}ms`,
                  animationDuration: '1s'
                }}
              />
            ))}
          </div>
        );
      
      case 'ring':
        return (
          <div className={`${sizeClass} border-4 border-gray-200 border-t-4 ${borderColorClass} rounded-full animate-spin`} />
        );
      
      default:
        return (
          <div className={`${sizeClass} animate-spin rounded-full border-4 border-gray-200 ${borderColorClass} border-t-transparent`} />
        );
    }
  };

  const loaderContent = (
    <div className={`flex flex-col items-center justify-center space-y-4 ${className}`}>
      <div role="status" aria-label={text}>
        {renderVariant()}
      </div>
      
      {text && (
        <div className="text-sm font-medium text-gray-600 dark:text-gray-400 text-center" aria-live="polite">
          {text}
        </div>
      )}
    </div>
  );

  if (fullScreen) {
    return (
      <div 
        className="fixed inset-0 z-50 flex items-center justify-center bg-white/80 dark:bg-gray-900/80 backdrop-blur-sm" 
        role="dialog" 
        aria-modal="true" 
        aria-label="Carregando aplicação"
      >
        {loaderContent}
      </div>
    );
  }

  if (overlay) {
    return (
      <div 
        className="absolute inset-0 z-40 flex items-center justify-center bg-white/70 dark:bg-gray-800/70 backdrop-blur-sm" 
        role="dialog" 
        aria-modal="true" 
        aria-label="Carregando conteúdo"
      >
        {loaderContent}
      </div>
    );
  }

  return loaderContent;
};

export default Loader;